/**
 * The "also send this email when I confirm" opt-in on the Move modal.
 *
 * Opt-in per email rather than a saved preference: sending to a candidate is
 * irreversible, so it should be a decision the recruiter makes while looking at
 * the text, not one made once and forgotten. It cannot be armed without a
 * connected Google account and a candidate address in Lever, and the label says
 * which of the two is missing instead of just being disabled.
 */
import { Checkbox } from '@finn-auto/design-system/atoms/checkbox';

export function SendOptIn({
  canSend,
  gmailConnected,
  candidateEmail,
  checked,
  disabled,
  onChange,
}: {
  canSend: boolean;
  gmailConnected: boolean;
  candidateEmail: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (next: boolean) => void;
}) {
  const label = canSend
    ? `Send this email to ${candidateEmail} when I confirm`
    : gmailConnected
      ? 'No candidate email on the Lever profile — cannot send from here'
      : 'Connect Google on the board to send from here';
  return (
    <>
      <Checkbox
        label={label}
        labelClassName="text-sm text-gray-700"
        checked={checked}
        disabled={!canSend || disabled}
        onCheckedChange={(v) => onChange(v === true)}
      />
      {checked && (
        <p className="text-xs text-gray-500">
          Sends from your own Gmail after a 10-second countdown you can stop. It lands in your Sent
          folder, so replies come back to you.
        </p>
      )}
    </>
  );
}
